import { render } from "./NewGroups.vue?vue&type=template&id=40c8ed1c&scoped=true"
import script from "./NewGroups.vue?vue&type=script&lang=js"
export * from "./NewGroups.vue?vue&type=script&lang=js"

import "./NewGroups.vue?vue&type=style&index=0&id=40c8ed1c&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c8ed1c"]])

export default __exports__